<template>
  <div class="section-four-container">
    <div class="reel-wrapper">
      <div class="reel-content">
        <div class="reel" ref="stage"></div>
        <div class="video-content-wrapper" @click="pauseVideo">
          <div class="video-content">
            <video
              ref="video"
              class=""
              src="//wenchangli.schtwz.cn/0709-100.mp4"
              :poster="imgPoster"
              :controls="isPlaying"
              preload="metadata"
              x-webkit-airplay="allow"
              airplay="allow"
              x5-video-player-type="h5"
              x5-video-orientation="portraint"
              x5-video-player-fullscreen="true"
              webkit-playsinline="true"
              playsinline="true"
              @pause="pauseVideo"
              @play="playVideo"
              @playing="playVideo"
            >您的浏览器不支持播放视频，请升级</video>
            <div class="play-button" v-if="!isPlaying" @click="playVideo"></div>
            <!-- x-webkit-airplay="allow"
              x5-video-player-type="h5"
              x5-video-orientation="portraint"
              :controls="isPlaying"
              x5-video-player-fullscreen="true"
              webkit-playsinline="true"
              playsinline="true" -->
            <!-- <div class="text-coming">敬请期待</div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="frame">2020江西文化发展巡礼宣传片</div>

    <!-- 底部两按钮 -->
    <div class="operation-group">
      <div class="operation operation-1" @click="$emit('slidePrev')"></div>
      <div class="operation operation-2" @click="$emit('slideNext')"></div>
    </div>

    <!-- 观众 -->
    <div class="audience"></div>
  </div>
</template>

<script>
import lottie from "lottie-web";
import anime from 'animejs';
import imgPoster from '@/assets/four/poster.png';

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      publicPath: process.env.BASE_URL,
      isPlaying: false,
      imgPoster,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    isActive(newVal) {
      if (newVal) {
        this.$emit("pauseMusic");
        this.enterAnimation();
        return;
      }
      this.pauseVideo();
      this.$emit("playMusic");
    }
  },
  methods: {
    init() {
      this.animation = lottie.loadAnimation({
        container: this.$refs.stage, // the dom element that will contain the animation
        renderer: "canvas",
        autoplay: false,
        loop: false,
        path: `${this.publicPath}juanzhou.json` // the path to the animation json
      });

      this.animation.addEventListener("data_ready", () => {
        this.$emit("mounted");
      });
    },
    playVideo() {
      requestAnimationFrame(() => {
        this.$refs.video.play();
        this.isPlaying = true;
      });
    },
    pauseVideo() {
      if (!this.isPlaying) return;
      // this.isPlaying = false;
      // this.$refs.video.pause();
    },
    enterAnimation() {
      this.animation.goToAndPlay(0, false);
      anime({
        targets: '.section-four-container .video-content',
        width: ['0%', '100%'],
        easing: 'linear',
        delay: 400,
        duration: 1400,
      });
      // anime({
      //   targets: '.section-four-container .play-button',
      //   opacity: [0, 1],
      //   easing: 'linear',
      //   delay: 0,
      //   duration: 2000,
      // });
      anime({
        targets: '.section-four-container .audience',
        opacity: [.3, .6, 1],
        translateY: ['100%', '0%'],
        duration: 1800,
        delay: 200,
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.section-four-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(~@/assets/four/bg.png) center center / 100% 100% no-repeat;
}
.reel-wrapper {
  position: absolute;
  left: 0;
  top: 14.516393%;
  width: 100%;
  padding-top: 80%;
  .reel-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .reel {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
.video-content-wrapper {
  z-index: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -53.5%);
  width: 90.9333333%;
  height: 50.3333333%;
  .video-content {
    position: relative;
    width: 0%;
    height: 100%;
    overflow: hidden;
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .text-coming {
    z-index: 9;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 120px;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: #333;
    letter-spacing: 10px;
  }
  .play-button {
    z-index: 9;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 52px;
    height: 52px;
    transform: translate(-50%, -50%);
    background: url(~@/assets/four/play_button.png) center center / 100% 100%
      no-repeat;
    cursor: pointer;
    &:active {
      opacity: 0.7;
    }
  }
}

.frame {
  position: absolute;
  left: 50%;
  top: 14.516393%;
  width: 272px;
  height: 51px;
  margin: 74% 0 0 -136px;
  line-height: 51px;
  text-align: center;
  font-size: 16px;
  background: url(~@/assets/four/frame.png) center center / 100% 100%
    no-repeat;
  color: #815841;
  @media screen and (min-height: 600px) {
    margin-top: 80%;
  }
}

// 底部两按钮
.operation-group {
  z-index: 99;
  position: absolute;
  left: 50%;
  bottom: 49px;
  transform: translate(-50%, 0);
  display: flex;
  .operation {
    width: 115px;
    height: 43px;
    cursor: pointer;
  }
  .operation-1 {
    background: url(~@/assets/to_prev.png) center center / 100% 100% no-repeat;
  }
  .operation-2 {
    margin-left: 44px;
    background: url(~@/assets/four/to_next.png) center center / 100% 100% no-repeat;
  }
}
.audience {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 244px;
  background: url(~@/assets/four/audience.png) center center / 100% 100%
    no-repeat;
}
</style>